import { setSnackbarForEndpoint } from "../../utils/snackbar";
import { sepAPI } from "../API/sepAPI";
import {
  EmailNotifications,
  EmailNotificationsUpdateBody,
} from "../../../shared/types/EmailNotifications";
import { emailNotificationsType } from "../../utils/emailNotificationTypes";

// Helper function to get notification label from type
const getNotificationLabel = (type: string): string => {
  const notification = emailNotificationsType.find(n => n.type === type);
  return notification?.label || type || 'Notification';
};

export const emailNotificationsSlice = sepAPI.injectEndpoints({
  endpoints: (builder) => ({
    updateEmailNotification: builder.mutation<
      EmailNotifications,
      { id: number; body: EmailNotificationsUpdateBody }
    >({
      query: (data) => {
        const { id, body } = data;
        return {
          url: `email-notifications/${id}`,
          method: "PATCH",
          body: body,
        };
      },
      invalidatesTags: ["EmailNotification"],
      onQueryStarted: (arg, api) => {
        const notificationLabel = getNotificationLabel((arg.body as any)?.notificationType);
        setSnackbarForEndpoint(api, {
          successMessage: `'${notificationLabel}' settings have been updated.`,
          errorMessage: "There was a problem updating the email notification.",
        });
      },
    }),

    createEmailNotification: builder.mutation<
      EmailNotifications,
      { body: any }
    >({
      query: (data) => {
        const { body } = data;
        return {
          url: `email-notifications`,
          method: "POST",
          body: body,
        };
      },
      invalidatesTags: ["EmailNotification"],
      onQueryStarted: (arg, api) => {
        const notificationLabel = getNotificationLabel((arg.body as any)?.notificationType);
        setSnackbarForEndpoint(api, {
          successMessage: `'${notificationLabel}' has been enabled.`,
          errorMessage: "There was a problem creating the email notification.",
        });
      },
    }),

    getEmailNotifications: builder.query<Array<EmailNotifications>, void>({
      query: () => `email-notifications`,
    }),

    deleteEmailNotification: builder.mutation<
      void,
      { id: number }
    >({
      query: (data) => {
        const { id } = data;
        return {
          url: `email-notifications/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["EmailNotification"],
      onQueryStarted: (arg, api) => {
        setSnackbarForEndpoint(api, {
          successMessage: "Email notification has been disabled.",
          errorMessage: "There was a problem deleting the email notification.",
        });
      },
    }),
  }),
});

export const {
  useUpdateEmailNotificationMutation,
  useCreateEmailNotificationMutation,
  useGetEmailNotificationsQuery,
  useDeleteEmailNotificationMutation,
} = emailNotificationsSlice;
